export default "__VITE_ASSET__BMUwG6Rj__"